document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('leadModal');
    const form = document.getElementById('leadForm');
    const leadMessage = document.getElementById('leadMessage');
    const closeBtn = document.querySelector('.lead-close');
    const submitBtn = document.querySelector('.form-submit');
    const loaderIcon = document.querySelector('.c-loader');
    const buttons = document.querySelectorAll('.pkg_button');
    const fields = document.querySelectorAll('.form-field');

    buttons.forEach(btn => {
        btn.addEventListener('click', function (e) {
        e.preventDefault();

        const pkgBox = btn.closest('.package_box');
        const checkbox = pkgBox.querySelector('.subs_checkbox');
        
        const sub = checkbox ? checkbox.checked : false;
        const sku = pkgBox.querySelector('.pkg_heading').getAttribute('data-sku');
        const price = pkgBox.querySelector('.pkg_list_price').getAttribute('data-price');
        const heading = pkgBox.querySelector('.pkg_heading')?.textContent.trim();

        form.fullname.value = '';
        form.email.value = '';
        form.sku.value = sub ? sku + "-sub" : sku;
        form.price.value = price;
        form.title.value = heading;

        leadMessage.innerHTML = `Thank you for your interest in <strong>${heading}</strong>.<br/> Please enter your Full Name and Email to be notified of its availability.`;

        modal.classList.remove('hidden');
        });
    });

    closeBtn.addEventListener('click', () => {
        modal.classList.add('hidden');
        submitBtn.style.display = 'block';
        fields.forEach(field => {
            field.style.display = 'inline-block';
        });
        loaderIcon.style.display = 'none';
    });

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitBtn.style.display = 'none';
        fields.forEach(field => {
            field.style.display = 'none';
        });
        loaderIcon.style.display = 'block';

        const formData = new FormData(form);

        fetch('https://script.google.com/macros/s/AKfycby9pbx0D1qVVXoWC4GU3y07mHfB03_Wnpzg0QHeQUv0K7j4QiCo8fEInMpmfitiQQu2/exec', {
            method: 'POST',
            body: formData // no headers needed!
        })
        .then(response => response.text())
        .then(data => {
            leadMessage.innerHTML = `<strong>Thank you!</strong> We'll notify you as soon as the product is back in stock.`;
            form.reset();
            setTimeout(() => {
                submitBtn.style.display = 'block';
                fields.forEach(field => {
                    field.style.display = 'inline-block';
                });
                loaderIcon.style.display = 'none';
                modal.classList.add('hidden')
            }, 2500);

        })
        .catch(error => {
            console.error('Error:', error);
            leadMessage.innerHTML = `There was an error. Please try again.`;
        });
    });
});

$(document).ready(function(e) {
	
	$('.close_icon').click(function(e) {
        $('.top_bar').slideUp();
    });

	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#getOrder").offset().top - 50
		}, 2000);
	});
	
	$('.subs_checkbox').on('change', function () {
		var $checkbox = $(this); // current checkbox
		var $button = $checkbox.closest('.package_box').find('.pkg_button'); // find button in same box
	
		if ($checkbox.is(':checked')) {
			$button.text('Subscribe Now');
		} else {
			$button.text('Add To Cart');
		}
	});
	
	
	$('.sec4_img_slide').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		autoplay: false,
		autoplaySpeed: 11000,
		dots: true,
		responsive: [
			
			{
				breakpoint: 767,
				settings:{slidesToShow: 2, variableWidth:true, centerMode:true}
				
			}
		]
	});
	
	//accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
});

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
});

document.addEventListener("DOMContentLoaded", function () {
    let currentPlaying = null; // Track the currently playing video

    // Click on image or play button to play video
    document.addEventListener("click", function (event) {
        let imgBox = event.target.closest(".video_box_img_box");

        if (imgBox) {
            let container = imgBox.closest(".video_box");
            let video = container.querySelector("video");

            // If another video is playing, pause it
            if (currentPlaying && currentPlaying !== video) {
                currentPlaying.pause();
                let prevContainer = currentPlaying.closest(".video_box");
                prevContainer.querySelector(".video_box_img_box").style.display = "block";
                currentPlaying.style.display = "none";
            }

            // Hide image & play video
            imgBox.style.display = "none";
            video.style.display = "block";
            video.play();

            currentPlaying = video;
        }
    });

    // When the video ends, show the image again
    document.addEventListener("ended", function (event) {
        let video = event.target;
        let container = video.closest(".video_box");
        let imgBox = container.querySelector(".video_box_img_box");

        imgBox.style.display = "block";
        video.style.display = "none";
        video.currentTime = 0;
        video.pause();

        currentPlaying = null;
    }, true);
});